import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import * as yup from "yup";
import { useStyles } from "../../../../../shared/styles/useStyles";
import { AppState } from "../../../../../redux/reducers/rootReducer";
import { IContractingOffice } from "../../../../../redux/types/types";
import { startSetContractingOffice } from "../../../../../redux/actions/correspondenceActions";

function usePrivacyPolicyForm() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const intl = useIntl();

  const { contractingOffice } = useSelector(
    (state: AppState) => state.correspondence
  );

  const initialValues = {
    PPUrl: contractingOffice?.PPUrl ?? "",
  };

  const validationSchema = yup.object({
    PPUrl: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredUrl" })}`),
  });

  const submit = async ({ PPUrl }: { PPUrl: string }) => {
    const contractingOfficeData: IContractingOffice = {
      ...contractingOffice,
      PPUrl,
    } as IContractingOffice;

    await dispatch(
      startSetContractingOffice(
        contractingOfficeData,
        "urlSuccessfullyPolicy",
        "urlError"
      )
    );
  };

  return { classes, initialValues, submit, intl, validationSchema };
}

export default usePrivacyPolicyForm;
